import C from '../constants';

export const rating = (state = [], action) => {
    switch (action.type) {
        case C.UPDATE_RATING:
            return [...action.rating];
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/reducers/rating.jsx